(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-info-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  const btn = document.querySelector('.fib-locale__btn');
  const panel = document.getElementById('fib-locale-panel');
  if (!btn || !panel) return;

  btn.addEventListener('click', function () {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });

  document.addEventListener('click', function (e) {
    if (!btn.contains(e.target) && !panel.contains(e.target)) {
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }
  });

  panel.addEventListener('click', function (e) {
    const option = e.target.closest('.fib-locale__option');
    if (!option) return;
    e.preventDefault();

    const isLanguage = option.dataset.type === 'language';
    const value = option.dataset.value;

    if (isLanguage) {
      document.getElementById('fib-language-input').value = value;
    } else {
      document.getElementById('fib-country-input').value = value;
    }

    document.getElementById('fib-localization-form').submit();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
